import React from "react";
import {
  makeStyles,
  createStyles,
  Popover,
  Typography,
  Button,
  Theme,
} from "@material-ui/core";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    typography: {
      padding: "0.25rem",
      fontWeight: "bold",
    },
    popoverName: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      backgroundColor: theme.palette.background.default,
    },
    popoverButton: {
      padding: "0.5rem",
      width: "100%",
      textAlign: "left",
    },
  })
);

interface Props {
  username: string;
  anchorEl: HTMLElement | null;
  handleChangePassword: () => void;
  handleLogout: () => void;
  handleClose: () => void;
}

/** サイドバーナビゲータコンテキストメニュー */
export function SidebarNavContextMenu(props: Props) {
  const classes = useStyles();

  const {
    username,
    anchorEl,
    handleChangePassword,
    handleLogout,
    handleClose,
  } = props;

  //--------------------
  // コンポーネント
  return (
    <Popover
      id="id_avatar_menu"
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <div>
        <div className={classes.popoverName}>
          <Typography component="span" className={classes.typography}>
            {username}
          </Typography>
        </div>
        <div>
          <Button
            onClick={handleChangePassword}
            size="small"
            className={classes.popoverButton}
          >
            パスワード変更
          </Button>
        </div>
        <div>
          <Button
            onClick={handleLogout}
            size="small"
            className={classes.popoverButton}
          >
            ログアウト
          </Button>
        </div>
      </div>
    </Popover>
  );
}
